import { useEffect, useState } from 'react';
import DetectRTC from 'detectrtc';

const useDetectRTC = (): {
  rtcDetected: boolean,
  isWebRTCSupported: boolean,
  hasWebcam: boolean,
  hasMicrophone: boolean,
  isScreenCapturingSupported: boolean,
} => {
  const [rtcDetected, setRtcDetected] = useState<boolean>(false);
  const [detectRTC, setDetectRTC] = useState<typeof DetectRTC>(null);

  useEffect(() => {
    DetectRTC.load(() => {
      setDetectRTC(DetectRTC);
      setRtcDetected(true);
    });
  }, []);

  return {
    rtcDetected,
    isWebRTCSupported: detectRTC?.isWebRTCSupported,
    hasWebcam: detectRTC?.hasWebcam,
    hasMicrophone: detectRTC?.hasMicrophone,
    isScreenCapturingSupported: detectRTC?.isScreenCapturingSupported,
  };
};

export default useDetectRTC;
